import(/* webpackMode: "eager" */ "/Users/chorneiolha/Downloads/site-for-work/ReinEx/src/app/page.tsx");
